<template>
  <div :ref="refId" :id="refId" style="width: 100%;height:100%;"> {{ optionShow }}</div>
</template>

<script>
import resize from './mixins/resize'

import Highcharts from 'highcharts/highstock';
import cylinder from "highcharts/modules/cylinder";
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsDrilldown from 'highcharts/modules/drilldown';
import Highcharts3D from 'highcharts/highcharts-3d';
import { ref } from 'vue';

HighchartsMore(Highcharts)
HighchartsDrilldown(Highcharts);
Highcharts3D(Highcharts);
cylinder(Highcharts);


export default {
  props: {
    option: {
      type: Object,
      default: {
      }
    },
    refId: {
      type: String,
      default: 'chartEl'
    },
  },
  watch: {
    option: {
      handler(newVal, oldVal) {
        // this.chart = Highcharts.chart(this.refId, this.option);
      }
    }
  },

  computed: {
    optionShow() {
      this.initData(this.option)
      return ''
    }
  },

  data() {
    return {
      chart: null
    }
  },
  created() {

  },
  mounted() {

  },
  beforeDestroy() {

  },
  methods: {

    initData() {
      setTimeout(() => {
        // console.log("this.refId = ",this.refId)
        this.chart = Highcharts.chart(this.refId, this.option);
      }, 100)

      /* if (this.$refs[this.refId]) { 
         this.chart = Highcharts.chart(this.refId, this.option);
       } else {
         setTimeout(() => { 
           if (this.$refs[this.refId]) {
             this.chart = Highcharts.chart(this.refId, this.option);
           } else {
             setTimeout(() => {
               if (this.$refs[this.refId]) {
                 this.chart = Highcharts.chart(this.refId, this.option);
               } else {
                 if (this.$refs[this.refId]) {
                   this.chart = Highcharts.chart(this.refId, this.option);
                 } else {
                   setTimeout(() => {
                     if (this.$refs[this.refId]) {
                       this.chart = Highcharts.chart(this.refId, this.option);
                     } else {
                       console.log("渲染失败")
                     }
                   }, 500)
                 }
               }
             }, 200)
           }
         }, 50)
       }*/
      return ''
    }

  }
}
</script>

<style lang="scss" scoped>
.home-ticket-mian {
  width: 100%;


}
</style> 
</style>